import Widget from './Widget';
import Footer from './Footer';

Widget.Footer = Footer;
export default Widget;
